import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from '../../StaticText/connect'
import {
  PLAN_SKU_INCREASED_PRICE_MONTHLY,
  PLAN_SKU_INCREASED_PRICE_ANNUAL,
  PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  formatPrice,
} from '../../../services/plans/index'
import { USD } from '../../../services/currency/index'
import {
  H2,
  H3,
  H4,
  H5,
  HEADING_TYPES,
} from '../../Heading/index'
import Link from '../../Link/index'
import { TARGET_BLANK } from '../../Link/constants'
import {
  URL_MULTIPLE_PROFILE_HELP,
  URL_SHARE_FEATURE_HELP,
  URL_PAYMENT_TYPES_HELP,
  URL_FREE_TRIAL_HELP,
  URL_GO_PAGE,
  URL_GAIA_PLUS,
  URL_GAIA_PLUS_ALL_GUIDES,
} from '../../../services/url/constants'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_LINK, BUTTON_SIGN_UP_TYPE_BUTTON } from '../../ButtonSignUp/index'
import { TYPES } from '../../Button/index'

function InviteFriendPricingInfo (props) {
  const { plans = Map(), staticText = Map() } = props
  const plansData = Map.isMap(plans) && Map.isMap(plans.get('data')) ? plans.get('data', Map()) : Map()
  const plansDataPlans = List.isList(plansData.get('plans')) ? plansData.get('plans', List()) : List()
  const currencyIso = plansDataPlans.getIn([0, 'currencyIso']) || USD
  const monthlyPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_MONTHLY) || Map()
  const annualPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_ANNUAL) || Map()
  const gaiaPlusPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_GAIA_PLUS) || Map()
  const monthlyCost = monthlyPlan.get('costs', List([0])).last()
  const annualPlanPricePerMonth = annualPlan.get('costs', List([0])).last() / 12
  const priceDifference = (monthlyCost - annualPlanPricePerMonth).toFixed(2)
  const percentSavings = `${Math.floor(((priceDifference / monthlyCost) * 100).toFixed(2))}%`

  return (
    <section className="invite-friend-pricing-info">
      <div className="invite-friend-pricing-info__main">
        <H2
          as={HEADING_TYPES.H4}
          className="invite-friend-pricing-info__title"
        >
          {staticText.getIn(['data', 'whatDoWeOffer'])}
        </H2>
        <div className="invite-friend-pricing-info__columns">
          <div className="invite-friend-pricing-info__col1">
            <H3
              as={HEADING_TYPES.H6}
              className="invite-friend-pricing-info__subtitle"
            >
              {staticText.getIn(['data', 'pricingTitle'])}
            </H3>
            <p className="invite-friend-pricing-info__text">
              {staticText.getIn(['data', 'pricingOne'])}
            </p>
            <p className="invite-friend-pricing-info__text">
              {`${staticText.getIn(['data', 'pricingTwo1'])} `}
              <Link
                to={URL_MULTIPLE_PROFILE_HELP}
                target={TARGET_BLANK}
                className="invite-friend-pricing-info__text-link"
                directLink
              >
                {staticText.getIn(['data', 'pricingTwoLink1'])}
              </Link>
              {` ${staticText.getIn(['data', 'pricingTwo2'])}. `}
              <Link
                to={URL_SHARE_FEATURE_HELP}
                className="invite-friend-pricing-info__text-link"
                target={TARGET_BLANK}
                directLink
              >
                {staticText.getIn(['data', 'pricingTwoLink2'])}
              </Link>
              .
            </p>
            <p className="invite-friend-pricing-info__text">
              <ButtonSignUp
                text={staticText.getIn(['data', 'pricingThreeLink1'])}
                className="invite-friend-pricing-info__signup-link"
                type={BUTTON_SIGN_UP_TYPE_LINK}
                scrollToTop
              />
              {` ${staticText.getIn(['data', 'pricingThree1'])} `}
              <Link
                to={URL_PAYMENT_TYPES_HELP}
                className="invite-friend-pricing-info__text-link"
                target={TARGET_BLANK}
                directLink
              >
                {staticText.getIn(['data', 'pricingThreeLink2'])}
              </Link>
              {` ${staticText.getIn(['data', 'pricingThree2'])}. `}
              {`${staticText.getIn(['data', 'pricingThree3'])}.`}
            </p>
            <H3
              as={HEADING_TYPES.H6}
              className="invite-friend-pricing-info__subtitle"
            >
              {staticText.getIn(['data', 'uniqueTitle'])}
            </H3>
            <ul className="invite-friend-pricing-info__value-list">
              <li className="invite-friend-pricing-info__value-list-item">
                {staticText.getIn(['data', 'uniqueText1'])}
              </li>
              <li className="invite-friend-pricing-info__value-list-item">
                {staticText.getIn(['data', 'uniqueText2'])}
              </li>
              <li className="invite-friend-pricing-info__value-list-item">
                {staticText.getIn(['data', 'uniqueText3'])}
              </li>
            </ul>
          </div>
          <div className="invite-friend-pricing-info__col2">
            <H3
              as={HEADING_TYPES.H6}
              className="invite-friend-pricing-info__subtitle"
            >
              {staticText.getIn(['data', 'streamTitle'])}
            </H3>
            <p className="invite-friend-pricing-info__text invite-friend-pricing-info__text--last">
              {staticText.getIn(['data', 'pricingFour1'])}
            </p>
            <H3
              as={HEADING_TYPES.H6}
              className="invite-friend-pricing-info__subtitle"
            >
              {staticText.getIn(['data', 'gaiaFreeTitle'])}
            </H3>
            <p className="invite-friend-pricing-info__text invite-friend-pricing-info__text--last">
              {`${staticText.getIn(['data', 'gaiaFreeOne1'])} `}
              <Link
                to={URL_FREE_TRIAL_HELP}
                className="invite-friend-pricing-info__text-link"
                target={TARGET_BLANK}
                directLink
              >
                {staticText.getIn(['data', 'gaiaFreeOneLink'])}
              </Link>
              {` ${staticText.getIn(['data', 'gaiaFreeOne2'])}.`}
            </p>
            <H3
              as={HEADING_TYPES.H6}
              className="invite-friend-pricing-info__subtitle"
            >
              {staticText.getIn(['data', 'howMuchPerMonthTitle'])}
            </H3>
            <p className="invite-friend-pricing-info__text">
              {staticText.getIn(['data', 'howMuchPerMonth'])}
            </p>
          </div>
          <div className="invite-friend-pricing-info__col3">
            <ul className="invite-friend-pricing-info__list">
              <li className="invite-friend-pricing-info__list-item">
                <H4
                  as={HEADING_TYPES.H6}
                  className="invite-friend-pricing-info__list-item-title"
                >
                  <Link
                    to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_MONTHLY}`}
                    className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                    scrollToTop
                  >
                    {staticText.getIn(['data', 'monthlyPlan'])}
                  </Link>
                  {`: ${formatPrice(currencyIso, monthlyPlan.getIn(['costs', 0]), false)}`}
                </H4>
                <p className="invite-friend-pricing-info__list-item-text">
                  {staticText.getIn(['data', 'monthlyBillingDescription'])}
                </p>
              </li>
              <li className="invite-friend-pricing-info__list-item">
                <H4
                  as={HEADING_TYPES.H6}
                  className="invite-friend-pricing-info__list-item-title"
                >
                  <Link
                    to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_ANNUAL}`}
                    className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                    scrollToTop
                  >
                    {staticText.getIn(['data', 'annualPlan'])}
                  </Link>
                  {`: ${formatPrice(currencyIso, annualPlan.getIn(['costs', 0]), false)}`}
                </H4>
                <p className="invite-friend-pricing-info__list-item-text">
                  {staticText.getIn(['data', 'annualAndGaiaPlusBillingDescription'])}
                </p>
              </li>
              <li className="invite-friend-pricing-info__list-item">
                <H4
                  as={HEADING_TYPES.H6}
                  className="invite-friend-pricing-info__list-item-title"
                >
                  <Link
                    to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_GAIA_PLUS}`}
                    className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                    scrollToTop
                  >
                    {staticText.getIn(['data', 'gaiaPlusPlan'])}
                  </Link>
                  {`: ${formatPrice(currencyIso, gaiaPlusPlan.getIn(['costs', 0]), false)}`}
                </H4>
                <p className="invite-friend-pricing-info__list-item-text">
                  {staticText.getIn(['data', 'annualAndGaiaPlusBillingDescription'])}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="invite-friend-pricing-info__value-props">
          <H2
            as={HEADING_TYPES.H4}
            className="invite-friend-pricing-info__title"
          >
            {staticText.getIn(['data', 'gaiaSubscriptionPlans'])}
          </H2>
          <div className="invite-friend-pricing-info__columns">
            <div className="invite-friend-pricing-info__col1">
              <H3
                as={HEADING_TYPES.H6}
                className="invite-friend-pricing-info__subtitle"
              >
                {`${staticText.getIn(['data', 'gaia'])} `}
                <Link
                  to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_MONTHLY}`}
                  className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                  scrollToTop
                >
                  {staticText.getIn(['data', 'monthlyPlan'])}
                </Link>
                {` ${staticText.getIn(['data', 'includes'])}:`}
              </H3>
              <ul className="invite-friend-pricing-info__value-list">
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'freeTrial'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'unlimitedAccess'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'cancelAnytime'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'watchOnDevices'])}
                </li>
              </ul>
            </div>
            <div className="invite-friend-pricing-info__col2">
              <H3
                as={HEADING_TYPES.H6}
                className="invite-friend-pricing-info__subtitle"
              >
                {`${staticText.getIn(['data', 'gaia'])} `}
                <Link
                  to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_ANNUAL}`}
                  className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                  scrollToTop
                >
                  {staticText.getIn(['data', 'annualPlan'])}
                </Link>
                {` ${staticText.getIn(['data', 'includes'])}:`}
              </H3>
              <ul className="invite-friend-pricing-info__value-list">
                <li className="invite-friend-pricing-info__value-list-item">
                  {String(staticText.getIn(['data', 'savings'])).replace(/\$\{ savingsPercent \}/g, percentSavings)}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'freeTrial'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'unlimitedAccess'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'cancelAnytime'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'watchOnDevices'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'bonusContent'])}
                </li>
              </ul>
            </div>
            <div className="invite-friend-pricing-info__col3">
              <H3
                as={HEADING_TYPES.H6}
                className="invite-friend-pricing-info__subtitle"
              >
                <Link
                  to={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_GAIA_PLUS}`}
                  className="invite-friend-pricing-info__text-link invite-friend-pricing-info__text-link--bold"
                  scrollToTop
                >
                  {staticText.getIn(['data', 'gaiaPlus'])}
                </Link>
                {` ${staticText.getIn(['data', 'includes'])}:`}
              </H3>
              <ul className="invite-friend-pricing-info__value-list">
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'unlimitedAccess'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'cancelAnytime'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'watchOnDevices'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'bonusContent'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {`${staticText.getIn(['data', 'livestream'])} `}
                  <Link
                    to={URL_GAIA_PLUS}
                    className="invite-friend-pricing-info__text-link"
                    scrollToTop
                  >
                    {staticText.getIn(['data', 'gaiasphereEvents'])}
                  </Link>
                  {` ${staticText.getIn(['data', 'watchPastEvents'])}`}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {staticText.getIn(['data', 'chat'])}
                </li>
                <li className="invite-friend-pricing-info__value-list-item">
                  {`${staticText.getIn(['data', 'transform'])} `}
                  <Link
                    to={URL_GAIA_PLUS_ALL_GUIDES}
                    className="invite-friend-pricing-info__text-link"
                    scrollToTop
                  >
                    {staticText.getIn(['data', 'guides'])}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="invite-friend-pricing-info__cta">
        <H5
          as={HEADING_TYPES.H4}
          className="invite-friend-pricing-info__cta-title"
        >
          {`${staticText.getIn(['data', 'joinGaiaNow'])} `}
          <span className="invite-friend-pricing-info__cta-italic">
            {`${staticText.getIn(['data', 'toGetYour'])}`}
          </span>
          {` ${staticText.getIn(['data', 'free7dayTrial'])}`}
        </H5>
        <p className="invite-friend-pricing-info__cta-italic">
          {staticText.getIn(['data', 'exploreTitles'])}
        </p>
        <ButtonSignUp
          text={staticText.getIn(['data', 'startFreeTrial'])}
          className="invite-friend-pricing-info__cta-link"
          type={BUTTON_SIGN_UP_TYPE_BUTTON}
          buttonType={TYPES.ROYAL}
          scrollToTop
        />
      </div>
    </section>
  )
}

InviteFriendPricingInfo.propTypes = {
  plans: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'inviteFriendPricingInfo' }),
  connectRedux(
    (state) => {
      return {
        plans: state.plans,
      }
    },
  ),
)(InviteFriendPricingInfo)
